import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { ConcessaoService } from '../../../../../../services/mob/concessao.service';
import { VistoriaSearch } from '../../../../../../services/mob/vistoria.search';


@Component({
  selector: 'dropdown-concessao-coletivo-urbano',
  templateUrl: './dropdown-concessao-coletivo-urbano.component.html',
  styleUrls: ['./dropdown-concessao-coletivo-urbano.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class DropdownConcessaoColetivoUrbanoComponent implements OnInit {

  concessoes = []
  vistoriaSearch: VistoriaSearch
  formGroup: FormGroup;

  constructor(
    private _concessaoService: ConcessaoService,
    private _control: ControlContainer,
  ) { 
    
  }
  

  ngOnInit() {
    this.formGroup = this._control.control as FormGroup;
    this.load()

  }

  click($event){
    const concessao = this.concessoes.find((item) => item.concessao.cdConcessao == $event);
    if(this.formGroup.get('cdPessoa')){
      this.formGroup.get('cdPessoa').setValue(concessao.concessao.cdConcessionario, {emitEvent:false})
    }
  }

  
  load() {
    return this._concessaoService.findColetivoUrbano().then(r => {
      this.concessoes = r;
    });
  }

}
